import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const CommentIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  isActive = false,
  ...props
}) => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.99999 0.166687C13.6025 0.166687 17.3333 3.89752 17.3333 8.50002C17.3333 13.1025 13.6025 16.8334 8.99999 16.8334H2.33332C1.8913 16.8334 1.46737 16.6578 1.15481 16.3452C0.842251 16.0326 0.666656 15.6087 0.666656 15.1667V8.50002C0.666656 3.89752 4.39749 0.166687 8.99999 0.166687ZM8.99999 1.83335C7.23188 1.83335 5.53619 2.53573 4.28594 3.78598C3.0357 5.03622 2.33332 6.73191 2.33332 8.50002V15.1667H8.99999C10.7681 15.1667 12.4638 14.4643 13.714 13.2141C14.9643 11.9638 15.6667 10.2681 15.6667 8.50002C15.6667 6.73191 14.9643 5.03622 13.714 3.78598C12.4638 2.53573 10.7681 1.83335 8.99999 1.83335ZM8.99999 10.1667C9.21239 10.1669 9.41668 10.2483 9.57113 10.3941C9.72558 10.5399 9.81852 10.7391 9.83097 10.9512C9.84342 11.1632 9.77443 11.372 9.6381 11.5349C9.50178 11.6978 9.3084 11.8024 9.09749 11.8275L8.99999 11.8334H6.49999C6.28759 11.8331 6.0833 11.7518 5.92885 11.606C5.7744 11.4602 5.68146 11.2609 5.66901 11.0489C5.65657 10.8368 5.72555 10.628 5.86188 10.4652C5.9982 10.3023 6.19158 10.1976 6.40249 10.1725L6.49999 10.1667H8.99999ZM11.5 6.83335C11.721 6.83335 11.933 6.92115 12.0892 7.07743C12.2455 7.23371 12.3333 7.44567 12.3333 7.66669C12.3333 7.8877 12.2455 8.09966 12.0892 8.25594C11.933 8.41222 11.721 8.50002 11.5 8.50002H6.49999C6.27898 8.50002 6.06701 8.41222 5.91073 8.25594C5.75445 8.09966 5.66666 7.8877 5.66666 7.66669C5.66666 7.44567 5.75445 7.23371 5.91073 7.07743C6.06701 6.92115 6.27898 6.83335 6.49999 6.83335H11.5Z"
      fill={isActive ? 'url(#gradient)' : '#333333'}
    />
    {isActive && (
      <defs>
        <linearGradient
          id="gradient"
          x1="0.666656"
          y1="8.50002"
          x2="17.1514"
          y2="6.76824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD84BE" />
          <stop offset="0.5" stopColor="#FB7BDB" />
          <stop offset="1" stopColor="#BF78F2" />
        </linearGradient>
      </defs>
    )}
  </svg>
);

export default CommentIcon;
